import { Apollo } from 'src/gql/generated';

export interface Feature {
  text: string;
  title: string;
  highlight?: boolean;
}

export interface PlanType {
  features: Feature[];
  icon: string;
  id: Apollo.SubscriptionTier;
  minUsers: number;
  name: string;
  price: {
    seats: {
      basic: {
        monthly: number | 'Contact Us';
        yearly: number | 'Contact Us';
      };
      full: {
        monthly: number | 'Contact Us';
        yearly: number | 'Contact Us';
      };
    };
  };
  buttonVariant?: 'default' | 'secondary' | 'outline';
  description?: string;
  highlight?: boolean;
}

export const plans: PlanType[] = [
  {
    description: 'Perfect for growing teams.',
    features: [
      {
        text: 'Negotiate, approve, and sign documents with unlimited workflows.',
        title: 'Unlimited Workflows',
      },
      {
        text: 'Detect parent/child relationships and extract structured data from documents.',
        title: 'AI Repository',
      },
      {
        text: 'Draft, redline, and conduct deep research with Aline Associate and AI Playbooks.',
        title: 'AI Drafting, Redlining, and Research',
      },
      {
        text: 'Up to 20 hours of onboarding, implementation, and training.',
        title: 'Onboarding and Support',
      },
    ],
    highlight: true,
    icon: 'T',
    id: Apollo.SubscriptionTier.Team,
    minUsers: 0,
    name: 'Team Plan',
    price: {
      seats: {
        basic: {
          monthly: 150,
          yearly: 1500,
        },
        full: {
          monthly: 150,
          yearly: 1500,
        },
      },
    },
  },
  {
    buttonVariant: 'secondary',
    description: 'For large organizations and firms.',
    features: [
      {
        text: 'All features and capabilities in Team, including Aline AI and Workflows.',
        title: 'Everything in Team',
      },
      {
        text: 'Integrate with 10+ leading CRMs, file storage, and HR tools.',
        title: 'Integrations',
      },
      {
        text: 'Single Sign-On (SSO), Directory Sync, and Aline Groups for seamless user management.',
        title: 'SSO and Directory Sync',
      },
      {
        text: 'Onboarding, implementation, and training tailored to your Enterprise.',
        title: 'Bespoke Onboarding',
      },
    ],
    icon: 'E',
    id: Apollo.SubscriptionTier.Enterprise,
    minUsers: 0,
    name: 'Enterprise Plan',
    price: {
      seats: {
        basic: {
          monthly: 'Contact Us',
          yearly: 'Contact Us',
        },
        full: {
          monthly: 'Contact Us',
          yearly: 'Contact Us',
        },
      },
    },
  },
];
